// publicDataConfigs.js
// Per-source config for the generic public-data import page. Adding 1000 Genomes
// later is just another entry here + a backend adapter.

const UUID_RE = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const SRA_CONFIG = {
  source: "sra",
  title: "Download SRA Samples",
  itemWord: "sample",
  idHelp: "SRA Run IDs (one per line) — max 50 at once. IDs must begin with 'SRR', 'ERR', or 'DRR'.",
  requestsPath: "/sra-requests",
  // Format check for the entered IDs (returns an error string, or null if OK).
  localValidate: (ids) =>
    ids.some((id) => !(id.startsWith("SRR") || id.startsWith("ERR") || id.startsWith("DRR")))
      ? "Each SRA Run ID must start with 'SRR', 'ERR', or 'DRR'."
      : null,
};

export const GDC_CONFIG = {
  source: "gdc",
  title: "Download TCGA / GDC Files",
  itemWord: "file",
  idHelp:
    "GDC FILE UUIDs (one per line) — max 50 at once. Enter file UUIDs only — the 'id' field of a GDC manifest — " +
    "NOT case/sample UUIDs. Only OPEN-access files can be downloaded; controlled data (raw BAM/FASTQ, germline VCFs) " +
    "requires dbGaP authorization and is not supported here.",
  docsLabel: "How to find file UUIDs (GDC documentation)",
  docsUrl: "https://docs.gdc.cancer.gov/Data_Portal/Users_Guide/Cart/",
  localValidate: (ids) =>
    ids.some((id) => !UUID_RE.test(id)) ? "Each entry must be a valid GDC file UUID." : null,
};

const TG_SAMPLE_RE = /^[A-Za-z]{2}[0-9]{4,6}$/; // HG00096 / NA12878 style

export const TG_CONFIG = {
  source: "1000g",
  title: "Download 1000 Genomes Data",
  itemWord: "file",
  idHelp:
    "1000 Genomes sample IDs (one per line) — max 50 at once (e.g. HG00096, NA12878). " +
    "We'll show every public file available for each sample across all phases; you pick which to download.",
  docsLabel: "Find sample IDs (IGSR / 1000 Genomes Data Portal)",
  docsUrl: "https://www.internationalgenome.org/data-portal/sample",
  requestsPath: "/tg-requests",
  localValidate: (ids) =>
    ids.some((id) => !TG_SAMPLE_RE.test(id))
      ? "Each entry must be a 1000 Genomes sample ID (e.g. HG00096 or NA12878)."
      : null,
};
